import { ListService } from "@/modules/List/services/ListService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import { Vue } from "vue-property-decorator";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { UserService } from "@/modules/User/services/UserService";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { UserQuery } from "@/modules/User/models/UserQuery";

export abstract class ListOfPropertiesValues extends Vue {
  abstract loadItems(
    field: string,
    idList?: string,
    keyword?: string
  ): Promise<DynamicSelectData[]>;

  abstract setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void;

  async getList(idList: string): Promise<DynamicSelectData[]> {
    try {
      const listService = new ListService();
      const listResponse = await listService.getListById(idList);
      if (listResponse.code === Http.Found) {
        return (listResponse.data?.options.map(item => ({
          id: item.id,
          name: item.title
        })) as unknown) as DynamicSelectData[];
      }

      return [];
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  async getUserByQuery(
    setFilters: (ref: string, name: string) => { UserQuery: UserQuery },
    name?: string
  ) {
    try {
      if (!name) return [];

      const filterQuery = setFilters(
        GENERAL_RULES_CONSTANTS.ID_REFERENCE,
        name
      );

      const userService = new UserService();
      const response = await userService.getUserByFilters(
        filterQuery as UserQuery
      );

      if (response.code !== Http.Found || !response.data) {
        Snackbar.popInfo(response.message);
        return;
      }
      const users = response.data.userArray;
      const userList: DynamicSelectData[] = [];
      users.forEach(item => {
        const user =
          item.name && item.name != "" ? item.name : item.userDocument ?? "";
        userList.push({
          id: item.id,
          name: user
        });
      });

      return userList;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
